import { atom, } from 'recoil';

export const vehicleSearchTypeState = atom({
  key: "vehicleSearchTypeState",
  default: "",
});

export const vehicleSearchStrState = atom({
  key: "vehicleSearchStrState",
  default: "",
});